export enum ACCESS_TO_DOCUMENT_TYPES {
  KP = "KP",
  KW = "KW",
}
